import { atom } from 'recoil';

export const errorValidation = atom({
  key: 'errorValidation',
  default: undefined,
});
